import { render, staticRenderFns } from "./TonosServicioTab.vue?vue&type=template&id=78911353&scoped=true&"
import script from "./TonosServicioTab.vue?vue&type=script&lang=js&"
export * from "./TonosServicioTab.vue?vue&type=script&lang=js&"
import style0 from "./TonosServicioTab.vue?vue&type=style&index=0&id=78911353&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78911353",
  null
  
)

export default component.exports